export const environment = {
  production: false,
  hmr: true,

  API: 'https://comotributar.sistemasfocuscontabil.com/backend/api/'
  //API: 'http://192.168.25.6:8004/api/'
  //API: 'https://localhost:44338/api/' 
  //Tunel produção
  // API: 'https://4r1jcq7w-44338.brs.devtunnels.ms/api/'
};
